import { useEffect, useState } from 'react';
import Styles from "../../styles.module.scss";
import SideMenu from "../../sideMenu";
import DashboardHeader from "../../dashboardHeader";
import WorkExperiance from "./workExperiance";
import SkillsTest from "./skillsTest";

import AlgorithmChallenge from "./algorithmChallenge";
import UploadVideo from "./uploadVideo";
import * as CONSTANTS from '../../../../utils/CONSTANTS';
import { makeSideBarActive } from '../../../../utils/EllowUtils';
import { getDetails } from '../../services';
import { getSkillBasedTests } from './services';




  

function Assessments() {

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [skillValues, setSkillValues] = useState<{
    techStack: { experience: string; expertise: number; skill: { skillId: number; skillName: string; }; stackId: number; }[],
  }>({
    techStack: [{ experience: "", expertise: 0, skill: { skillId: 0, skillName: '' }, stackId: 0 }]
  })

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [testonSkills, setTestonSkills] = useState<{skill_id:number; skill_name:string; status:boolean; test_id:string; freelancer_skill:boolean; created_on:string; updated_on:string; top_rated:number;}[]>
    ([
      // {skill_id:1278,skill_name:"ReactJS",status:true,test_id:"1880101",freelancer_skill:true,created_on:"1598693043",updated_on:"1598693043",top_rated:1}
    ])

    const [testDetails, setTestDetails] = useState<
      {
        HackerEarth : {creation_datetime:string , cutoff_score:number ,duration:number , end_datetime:string , id:number , practice_test_slug: string ,
              problem_types_data :{MultipleChoiceQuestions : { total_score: number,num_problems: number} , Programming: {total_score: number, num_problems: number} , SQL: {total_score: number, num_problems: number}},
              slug: string , title: String, icon_url:string
        },
        UserInfo: {
          status: string,
          is_passed: string
        }
      }[]
    >([
      
      // {HackerEarth : {creation_datetime:"" , cutoff_score:1 , duration:2700 ,end_datetime:" " ,id:1915616 , practice_test_slug: "practice-test-138875" ,
      //     problem_types_data : { MultipleChoiceQuestions : { total_score: 24, num_problems: 8} , Programming: {total_score: 20, num_problems: 1} , SQL: {total_score: 10, num_problems: 1} },
      //     slug: "backend-developer-nodejs-test-72" ,  title: "Backend Developer - Node.js test" ,
      // },
      // UserInfo:""
      // }
    ])

    const [step] = useState<number>(1)
    const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 3)
    const loginId: string = localStorage.getItem('loginId') || ''
    const [userData, setUserData] = useState<{email: string, firstname: string, lastname: string}>({email: '', firstname: '', lastname: ''})
    const [surveyStatus, setSurveyStatus] = useState<any>()

   useEffect(() => {

    getAllTestDetails(loginId)
    getCandidateDetails()
    // getSkillBasedTests(loginId);

    
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   const getAllTestDetails = (id: string) => {
     let data = {
       loginId: id
     }
    getSkillBasedTests(data).then((response) =>{ 
      if(response ){ 
        setUserData(response[0].userData)
        setTestDetails(response[0].Response)
         
        // setValues(response)   
        // setTestonSkills(response)
      }      
   })
   }
  

  const getCandidateDetails = () => {
    getDetails(loginId).then((response) => {
      if (response && response.status === 1) {
        setSurveyStatus(response.data[0].is_survey_completed)
        localStorage.setItem('availablityId',response.data[0].profile_metadata.availability.availabilityId)
      if(response.data[0].profile_metadata.availability.availabilityId === 2){
        localStorage.setItem('date',response.data[0].profile_metadata.availability.date && response.data[0].profile_metadata.availability.date )
      }
      if(response.data[0].profile_metadata.availability.availabilityId === 3){
      localStorage.setItem('weeks',response.data[0].profile_metadata.availability.weeks)
      }  
       }
    })
  }



    return (
      // <ComingSoon/>
        <section className={Styles.dashboardWrapper}>
            <SideMenu menu={menu} />

            <div className={Styles.dashboardContent}>
                <DashboardHeader />
                <div className="contentBox mb-40">
                    <div className="innerPadd48">
                        <div className={Styles.asseeDescription}>
                        Hey! You are just a single step away from unlocking the marvelous job opportunities in store for you. Yes, Clear the tests that match your core skills and Ellow find the best match waiting for you…
                        </div>
                        {/* <div className={Styles.testStepper}>
                            <StepperDefault onChange={(e:any) => handleChange(e)} items={items} value={step} />
                        </div> */}
                        {step ===0 && <WorkExperiance/> }
                        {step === 1 && <SkillsTest defaultValues={skillValues} testDetails={testDetails} testSkills={testonSkills} loginId={loginId} userData={userData} surveyStatus={surveyStatus} getCandidateDetails={getCandidateDetails} />}
                        {step ===2 && <AlgorithmChallenge/>}
                        {step ===3 && <UploadVideo/>}
                        
                      </div>
                  </div>
                  {/* <OtherSkillTest/> */}
               
              </div>
         </section>
    );
}
export default Assessments